
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import EventDetails from './components/EventDetails';
import CoupleBio from './components/CoupleBio';
import Registry from './components/Registry';
import RSVPForm from './components/RSVPForm';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <Hero />
      <EventDetails />
      <CoupleBio />
      <Registry />
      <RSVPForm />
      <Contact />
      <Footer />
    </div>
  );
}
